
import { Placement } from '@post-office/placements-frontend/live-nudge-demo';
export default Placement;
